import { render, staticRenderFns } from "./musculoskeletalSystemJob.vue?vue&type=template&id=653bafa6"
import script from "./musculoskeletalSystemJob.vue?vue&type=script&lang=js"
export * from "./musculoskeletalSystemJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653bafa6')) {
      api.createRecord('653bafa6', component.options)
    } else {
      api.reload('653bafa6', component.options)
    }
    module.hot.accept("./musculoskeletalSystemJob.vue?vue&type=template&id=653bafa6", function () {
      api.rerender('653bafa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/musculoskeletalSystemJob.vue"
export default component.exports